import { render } from "./ReportsHistory.vue?vue&type=template&id=15c8555e"
import script from "./ReportsHistory.vue?vue&type=script&lang=js"
export * from "./ReportsHistory.vue?vue&type=script&lang=js"

import "./ReportsHistory.vue?vue&type=style&index=0&id=15c8555e&lang=scss"

import exportComponent from "/var/www/html/gonapsacc-11/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__